/**
 * Backstop detector for a workspace permission 403 (Gap 1).
 *
 * The API client (`core/api/client.ts`) rejects with a plain object
 * `{ message, statusCode }`, not an `AxiosError`. A delegate missing a
 * `DelegationPermission` gets `403` with a message like
 * "Missing required workspace permission: PROFILE_MANAGEMENT". Surfaces that
 * may still receive this (e.g. a race after a mid-session permission edit)
 * use this helper to render a graceful denied state instead of a raw error.
 */

type MaybeApiError = {
  statusCode?: number;
  status?: number;
  message?: unknown;
};

export function isWorkspacePermissionError(error: unknown): boolean {
  if (!error || typeof error !== 'object') return false;

  const candidate = error as MaybeApiError;
  const statusCode = candidate.statusCode ?? candidate.status;
  if (statusCode !== 403) return false;

  const message = typeof candidate.message === 'string' ? candidate.message : '';
  return /workspace permission/i.test(message);
}
